module.exports = __webpack_public_path__ + "img/3.c31bc0ce.jpg";